import {Injectable} from '@angular/core';

const TOKEN_KEY = 'Authorization';

@Injectable({
  providedIn: 'root'
})
export class TokenStorage {

  signOut() {
    localStorage.clear();
  }

  saveToken(token: string) {
    localStorage.setItem(TOKEN_KEY, token);
  }

  getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }
}
